<template>
    <div class="row">
        <div class="col-12 col-md-4 offset-md-2">
            <ibox
                :title="title_edit"
            >
                <template
                    slot="content"
                    slot-scope="{ setLoading }"
                >
                    <user-edit-form
                        slot="content"
                        @loading="setLoading"
                    />
                </template>
            </ibox>
        </div>
        <div class="col-12 col-md-4">
            <ibox
                :title="title_password"
            >
                <template
                    slot="content"
                    slot-scope="{ setLoading }"
                >
                    <user-password-form
                        slot="content"
                        @loading="setLoading"
                    />
                </template>
            </ibox>
        </div>
    </div>
</template>

<script>
import Ibox from '@/components/Ibox'
import UserEditForm from '@/components/Users/UserEditForm'
import UserPasswordForm from '@/components/Users/UserPasswordForm'
import UserDismiss from '@/components/Users/UserDismiss'

export default {
    name: 'UsersAdd',
    data() {
        return {
            title_edit: 'Edycja użytkownika',
            title_password: 'Zmiana hasła',
            title_dismiss: 'Zwolnij pracownika'
        }
    },
    components: {
        Ibox,
        UserEditForm,
        UserPasswordForm,
        UserDismiss
    }
}
</script>
